import React, { useContext } from 'react'
import classnames from 'classnames'
import { CategoryItemType } from '../../types'
import { TypeListContext } from '../../context'
import styles from './index.module.less'
import { LangEum } from '@/constant'

interface Props {
  dataSource: CategoryItemType[]
  activeKey: number
}

function Item(props: { data: CategoryItemType; isActive: boolean }) {
  const { data, isActive } = props

  const { onTypeChange, lang } = useContext(TypeListContext)
  return (
    <div
      onClick={() => {
        onTypeChange(data.key, data.id)
      }}
      className={classnames({
        [styles['item-wapper']]: true,
        [styles['item_active']]: isActive,
        [styles['item-wapper-en']]: lang === LangEum.en,
      })}
    >
      {data.title}
    </div>
  )
}

function List(props: { dataSource: CategoryItemType[]; activeKey: number }) {
  return (
    <div className={styles['list-wrapper']}>
      {props.dataSource.map((ele) => {
        return <Item isActive={ele.key === props.activeKey} key={ele.key} data={ele} />
      })}
    </div>
  )
}

function TypeList(props: Props) {
  const { dataSource, activeKey } = props

  return (
    <div className={styles['type-list-wrapper']}>
      <div className={styles['type-list-content-wrapper']}>
        <div className={styles['type-list-content']}>
          <List activeKey={activeKey} dataSource={dataSource} />
        </div>
      </div>
    </div>
  )
}

export default React.memo(TypeList)
